import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { Color } from "capitalrx-components-2.0/lib/general";

import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

import { Body } from "capitalrx-components-2.0/lib/typography";
import { OverlayContainer, AlertProvider, TooltipContainer } from "capitalrx-components-2.0/lib/general";

import { AuthenticationProvider, ThemeSelectorProvider } from "@/context";

import { getClientID } from "@/utils";
import AppRoutes from "@/routes";
import "./scss/style.scss";
import { setAnalyticsEligibilityInfo } from "./service";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const Root = (): JSX.Element => {
  const client = getClientID();
  const name = "";
  setAnalyticsEligibilityInfo(client, name);
  return (
    <OverlayContainer>
      <TooltipContainer>
        <AlertProvider>
          <BrowserRouter>
            <QueryClientProvider client={queryClient}>
              <Body>
                <AuthenticationProvider>
                  <ThemeSelectorProvider client={client}>
                    <AppRoutes />
                  </ThemeSelectorProvider>
                </AuthenticationProvider>
              </Body>
            </QueryClientProvider>
          </BrowserRouter>
        </AlertProvider>
      </TooltipContainer>
    </OverlayContainer>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);

if (root !== null) {
  document.body.style.backgroundColor = Color.toString(Color.White);
  root.render(<Root />);
} else {
  throw new Error("Unable to locate app root");
}
